import { render } from "./HairGallery.vue?vue&type=template&id=17bdba27"
import script from "./HairGallery.vue?vue&type=script&lang=js"
export * from "./HairGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__